export const formatReadiness = (readiness: number): string => {
   return (readiness * 100).toFixed(0).toString();
};
